import React from "react";

const noResult = props => {
    let text = props.hasError ? "Daha sonra tekrar deneyin." : "Sonuç bulunamadı..."
    return <div className="ps-no-result"><p>{text}</p></div>
}

export default noResult;
